import types from './RequestSortType';

export default class RequestSortTitle {
    static [types.DATE] = 'По дате';
    static [types.DEADLINE] = 'По сроку';
    static [types.ACTIVITY] = 'По активности';
    static [types.ID] = 'По номеру';
    static [types.STATUS] = 'По статусу';
    static [types.AUTHOR] = 'По автору';
    static [types.EXECUTOR] = 'По исполнителю';
    static [types.SERVICE] = 'По услуге';
    static [types.CATEGORY] = 'По категории';
    static [types.CITY] = 'По городу';
    static [types.GROUP] = 'По группе';
    static [types.PRIORITY] = 'По приоритету';
}
